import { createContext, useCallback, useContext, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import BookingForm from "@/components/BookingForm";
import { BUSINESS } from "@/data/business";

const BookingContext = createContext({ openBooking: () => {} });

export const useBooking = () => useContext(BookingContext);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [service, setService] = useState("");

  const openBooking = useCallback((svc = "") => {
    setService(svc);
    setOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="booking-dialog"
          className="max-h-[90vh] overflow-y-auto border-charcoal/10 bg-ivory sm:max-w-lg"
        >
          <DialogHeader>
            <DialogTitle className="font-serif text-3xl font-medium text-charcoal">
              Book Appointment
            </DialogTitle>
            <DialogDescription className="text-sm text-charcoal/60">
              {BUSINESS.name} · {BUSINESS.hoursLine}
            </DialogDescription>
          </DialogHeader>
          <BookingForm
            key={service}
            formId="dialog-booking"
            initialService={service}
            onSubmitted={() => setOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </BookingContext.Provider>
  );
}
